<template>
   
  <footer id="footer">
     
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style>
</style>
